import { darken } from '@chakra-ui/theme-tools';
import { StyleFunctionProps } from '@telescope/cassini-ui';

export const modalTheme = {
  baseStyle: (props: StyleFunctionProps) => {
    const { semanticTokens } = props.theme;
    const closeButtonColor = semanticTokens.colors['Modal-close-button'];

    return {
      body: { p: [7, 0] },
      closeButton: {
        color: closeButtonColor,
        _hover: {
          color: darken(closeButtonColor, 20),
        },
        _active: {
          color: darken(closeButtonColor, 30),
        },
      },
    };
  },
};
